var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('div',{staticClass:"inner-wrap"},[_c('History',{staticClass:"mt-2",attrs:{"all-cv":_vm.AllCv,"sent-cv-history-count":_vm.SentCvHistoryCount}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }